import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

const faqs = [
  {
    category: "시작하기",
    items: [
      {
        q: "K-ArtPEN은 어떤 서비스인가요?",
        a: "K-ArtPEN은 주식회사 툴뮤직이 운영하는 문화예술 기업 경영 시뮬레이션 교육 플랫폼입니다. 음악 레이블, 공연기획사, 문화재단, 웹툰스튜디오, 광고에이전시 5개 기업 유형의 실제 경영 환경을 시뮬레이션할 수 있습니다.",
      },
      {
        q: "무료로 이용할 수 있나요?",
        a: "현재 베타 서비스 기간 중에는 기본 기능을 무료로 이용할 수 있습니다. 기관 단체 도입의 경우 별도 문의를 통해 가격과 조건을 안내받으실 수 있습니다.",
      },
      {
        q: "어떤 기기에서 이용할 수 있나요?",
        a: "웹 브라우저를 지원하는 PC에서 최적화되어 있습니다. Chrome, Edge, Safari 최신 버전에서의 이용을 권장합니다. 현재 모바일 앱은 제공하지 않습니다.",
      },
    ],
  },
  {
    category: "계정 및 워크스페이스",
    items: [
      {
        q: "강사 계정과 학생 계정의 차이는 무엇인가요?",
        a: "강사 계정은 워크스페이스를 직접 생성하고 학생을 초대하며, 모든 팀의 현황을 모니터링하고 이벤트를 발송할 수 있는 어드민 권한을 갖습니다. 학생 계정은 배정된 워크스페이스에서 특정 직무를 맡아 시뮬레이션에 참여합니다.",
      },
      {
        q: "워크스페이스는 어떻게 만드나요?",
        a: "강사 계정으로 로그인 후 어드민 페이지에서 '새 워크스페이스 생성'을 클릭합니다. 이름과 모드(솔로/팀)를 설정하면 참여 코드가 생성되며, 이 코드를 학생들에게 공유하면 참여할 수 있습니다.",
      },
      {
        q: "한 계정으로 여러 직무를 경험할 수 있나요?",
        a: "같은 워크스페이스 내에서는 하나의 직무만 담당합니다. 다른 직무를 경험하려면 강사에게 역할 재배정을 요청하거나 새로운 워크스페이스 세션에 참여해야 합니다.",
      },
    ],
  },
  {
    category: "시뮬레이션",
    items: [
      {
        q: "기업 유형은 어떻게 선택하나요?",
        a: "로그인 후 모드 선택 → 기업 유형 선택 화면에서 5개 유형(음악 레이블, 공연기획사, 문화재단, 웹툰스튜디오, 광고에이전시) 중 하나를 선택할 수 있습니다. 각 유형마다 직무 구성, KPI, 업무 시나리오가 다르게 제공됩니다.",
      },
      {
        q: "AI NPC와 협상이 어떻게 진행되나요?",
        a: "인박스 메뉴에서 직무별 거래처 NPC와 이메일 형식으로 협상을 진행합니다. 마케팅 담당은 광고주·기자 NPC와, 법무 담당은 유통사·투자자 NPC와 협상하게 됩니다. 협상 성공 시 자본금이나 명성 지수가 즉시 반영됩니다.",
      },
      {
        q: "강사가 발송하는 이벤트란 무엇인가요?",
        a: "강사가 어드민 페이지에서 특정 학생 팀에게 랜덤 이벤트(투자자 방문, 세무조사, 언론 보도 등)를 수동으로 발송할 수 있습니다. 발송 즉시 해당 팀의 대시보드에 팝업으로 표시되며, 자본금과 명성에 영향을 줍니다.",
      },
    ],
  },
  {
    category: "기관 도입",
    items: [
      {
        q: "기관 도입 시 어떤 지원을 받을 수 있나요?",
        a: "커리큘럼 맞춤 구성, 강사 어드민 계정 설정, 학생 계정 일괄 등록, 플랫폼 사용 교육 등을 지원합니다. 도입 문의 폼을 작성하시면 영업일 2일 이내에 담당자가 연락드립니다.",
      },
      {
        q: "최소 도입 인원이 있나요?",
        a: "최소 도입 인원 제한은 없습니다. 소규모 특강부터 학기 단위 정규 강의까지 규모에 맞게 유연하게 운영 가능합니다. 자세한 내용은 도입 문의를 통해 상담 받으세요.",
      },
    ],
  },
];

export default function FaqPage() {
  const navigate = useNavigate();
  const [openMap, setOpenMap] = useState<Record<string, boolean>>({});

  const toggle = (key: string) => setOpenMap(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="min-h-screen bg-[#0C0C0E]" style={{ fontFamily: PD }}>
      {/* Nav */}
      <nav className="bg-[#0C0C0E]/95 backdrop-blur border-b border-white/[0.05] px-6 h-14 flex items-center sticky top-0 z-30">
        <button type="button" onClick={() => navigate("/")}
          className="flex items-center gap-2 text-[#888888] hover:text-[#F2F2F2] text-sm transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-arrow-left-line"></i> K-ArtPEN
        </button>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-12 pb-8 border-b border-white/[0.06]">
          <p className="text-[#7A9BFF] text-xs uppercase tracking-widest mb-3">주식회사 툴뮤직 · K-ArtPEN</p>
          <h1 className="text-[#F2F2F2] text-3xl font-bold mb-3 leading-snug">자주 묻는 질문</h1>
          <p className="text-[#777777] text-sm">K-ArtPEN 이용에 관한 궁금증을 해결하세요.</p>
        </div>

        <div className="space-y-10">
          {faqs.map((section) => (
            <div key={section.category}>
              <h3 className="text-[#CCCCCC] text-sm font-semibold mb-4 flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#4B6CF7] inline-block"></span>
                {section.category}
              </h3>
              <div className="space-y-2">
                {section.items.map((item, i) => {
                  const key = `${section.category}-${i}`;
                  const isOpen = !!openMap[key];
                  return (
                    <div key={key} className="bg-[#111112] border border-white/[0.06] rounded-xl overflow-hidden">
                      <button
                        type="button"
                        onClick={() => toggle(key)}
                        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-white/[0.02] transition-colors"
                      >
                        <span className={`text-sm font-medium ${isOpen ? "text-[#F2F2F2]" : "text-[#CCCCCC]"}`}>{item.q}</span>
                        <i className={`ri-arrow-down-s-line text-[#555555] text-base transition-transform shrink-0 ml-3 ${isOpen ? "rotate-180" : ""}`}></i>
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-5 border-t border-white/[0.04]">
                          <p className="text-[#888888] text-sm leading-relaxed pt-4">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* 추가 문의 */}
        <div className="mt-14 bg-[#4B6CF7]/[0.06] border border-[#4B6CF7]/20 rounded-2xl p-7 text-center">
          <p className="text-[#CCCCCC] font-semibold text-base mb-2">찾으시는 답변이 없으신가요?</p>
          <p className="text-[#666666] text-sm mb-5">도입 문의 또는 기술 지원이 필요하시면 이메일로 문의해 주세요.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="mailto:eunhyun1@naver.com"
              className="text-[#7A9BFF] text-sm border border-[#4B6CF7]/30 px-6 py-2.5 rounded-xl hover:bg-[#4B6CF7]/10 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line mr-2"></i>eunhyun1@naver.com
            </a>
            <button type="button" onClick={() => { navigate("/"); setTimeout(() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }), 300); }}
              className="bg-[#4B6CF7] text-white text-sm px-6 py-2.5 rounded-xl hover:bg-[#5B7CF7] transition-colors cursor-pointer whitespace-nowrap">
              도입 문의 바로가기
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.05] py-8 text-center">
        <p className="text-[#555555] text-xs">© 2026 주식회사 툴뮤직. All rights reserved.</p>
      </div>
    </div>
  );
}
